import type { BeadPalette } from '../types';

const now = '2026-05-08T00:00:00.000Z';

export const genericMidiPalette: BeadPalette = {
  id: 'generic_midi_v1',
  name: 'Generic Midi Beads v1',
  brand: 'generic',
  beadSize: 'midi',
  createdAt: now,
  updatedAt: now,
  colors: [
    { id: 'transparent', brand: 'generic', name: 'Empty', hex: '#000000', symbol: '.' },
    { id: 'white', brand: 'generic', name: 'White', hex: '#FFFFFF', symbol: 'W' },
    { id: 'cream', brand: 'generic', name: 'Cream', hex: '#FFF1C7', symbol: 'C' },
    { id: 'black', brand: 'generic', name: 'Black', hex: '#151515', symbol: 'K' },
    { id: 'charcoal', brand: 'generic', name: 'Charcoal', hex: '#3D4247', symbol: 'H' },
    { id: 'red', brand: 'generic', name: 'Red', hex: '#D71920', symbol: 'R' },
    { id: 'coral', brand: 'generic', name: 'Coral', hex: '#FF7C66', symbol: 'Q' },
    { id: 'orange', brand: 'generic', name: 'Orange', hex: '#F28C28', symbol: 'O' },
    { id: 'yellow', brand: 'generic', name: 'Yellow', hex: '#FFD23F', symbol: 'Y' },
    { id: 'gold', brand: 'generic', name: 'Gold', hex: '#D9A326', symbol: 'Z' },
    { id: 'green', brand: 'generic', name: 'Green', hex: '#2BA84A', symbol: 'G' },
    { id: 'dark_green', brand: 'generic', name: 'Dark Green', hex: '#145A32', symbol: 'D' },
    { id: 'mint', brand: 'generic', name: 'Mint', hex: '#7BD9B1', symbol: 'I' },
    { id: 'teal', brand: 'generic', name: 'Teal', hex: '#2CA6A4', symbol: 'E' },
    { id: 'blue', brand: 'generic', name: 'Blue', hex: '#1D70B8', symbol: 'B' },
    { id: 'sky', brand: 'generic', name: 'Sky Blue', hex: '#74BDE8', symbol: 'U' },
    { id: 'navy', brand: 'generic', name: 'Navy', hex: '#1E3A5F', symbol: 'V' },
    { id: 'purple', brand: 'generic', name: 'Purple', hex: '#7A4EAB', symbol: 'P' },
    { id: 'lavender', brand: 'generic', name: 'Lavender', hex: '#B8A4E3', symbol: 'L' },
    { id: 'pink', brand: 'generic', name: 'Pink', hex: '#F4A6C1', symbol: 'N' },
    { id: 'magenta', brand: 'generic', name: 'Magenta', hex: '#C03A8B', symbol: 'J' },
    { id: 'brown', brand: 'generic', name: 'Brown', hex: '#7B4B2A', symbol: 'M' },
    { id: 'tan', brand: 'generic', name: 'Tan', hex: '#D9B382', symbol: 'T' },
    { id: 'skin', brand: 'generic', name: 'Skin', hex: '#F1C27D', symbol: 'S' },
    { id: 'gray', brand: 'generic', name: 'Gray', hex: '#808080', symbol: 'A' },
    { id: 'light_gray', brand: 'generic', name: 'Light Gray', hex: '#C8C8C8', symbol: 'F' }
  ]
};

export const palettes = [genericMidiPalette];

export function getPaletteColor(palette: BeadPalette, colorId: string) {
  return palette.colors.find((color) => color.id === colorId) ?? palette.colors[0];
}

export function visiblePaletteColors(palette: BeadPalette) {
  return palette.colors.filter((color) => color.id !== 'transparent');
}
